module.exports = __webpack_public_path__ + "static/media/Pres_2.20f866c3.png";